import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import AboutUs from "@/pages/AboutUs";
import Collection from "@/pages/Collection";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import ScrollToTop from "@/components/site/ScrollToTop";
import { Toaster } from "@/components/ui/sonner";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ScrollToTop />
                <Navbar />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<AboutUs />} />
                    <Route path="/collection" element={<Collection />} />
                </Routes>
                <Footer />
                <Toaster theme="dark" position="bottom-right" />
            </BrowserRouter>
        </div>
    );
}

export default App;
